<template>
  <div class="product">
    <div class="icon-wrapper">
      <img class="icon" :src="image">
    </div>

    <div class="product-info">
      <span class="label">{{ product.name }}</span>
      <span class="article-number">Artikelnr: {{ articleNumber || product.sku }}</span>
    </div>

    <emat-number
      name="input"
      :value="amount"
      @change="setProduct($event)"
    ></emat-number>

    <div class="prices">
      <div class="price"> {{ displayPrice }}</div>
    </div>
  </div>
</template>

<script>
import EmatButton from '../../General/Button';
import EmatNumber from '../../Inputs/Number';

export default {
  name: 'Product',

  props: {
    /**
     * * Product
     */
    product: {
      type: Object,
      required: true,
    },

    amount: {
      type: Number,
      default: 0,
    },

    articleNumber: {
      type: String,
      default: null,
    },

    /**
     * We calculate many times prices with as integers. For example 10.00 becomes 1000
     */
    minorUnits: {
      type: Boolean,
      default: false,
    },

    /**
     * Overwrites the default product.image_path if that property isn't present in the product object
     */
    customImage: {
      type: String,
      default: null,
    },
  },

  components: {
    EmatButton,
    EmatNumber,
  },

  methods: {
    setProduct(e) {
      this.$emit('setProduct', {
        ...this.product,
        amount: e,
      });
    },

    format(price) {
      if (this.minorUnits) {
        return (price / 100).toFixed(2).replace('.', ',');
      }

      return price.toFixed(2).replace('.', ',');
    },
  },

  computed: {
    displayPrice() {
      return this.format(this.product.price);
    },

    btw() {
      return this.format(this.product.price * 1.21);
    },

    image() {
      return this.customImage || this.product.image_url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.product {
  display: flex;
  padding: 10px 11px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media only screen and (max-width: 576px) {
    width: 100%;
  }

  .icon-wrapper {
    background-color: $white;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
    border-radius: $border-radius;
    width: 70px;
    height: 70px;

    .icon {
      padding: 6px;
      box-sizing: border-box;
      width: 70px;
      height: 70px;
    }
  }

  .product-info {
    margin-left: 20px;
    display: flex;
    margin-right: auto;
    flex-direction: column;
    flex-shrink: 1;

    @media only screen and (max-width: 576px) {
      width: 150px;
    }

    .label {
      font-weight: $font-weight-bold;
      font-size: 16px;
      color: var(--c-subtitle);

      @media only screen and (max-width: 576px) {
        font-size: 12px;
      }
    }

    .article-number {
      border-radius: 4px;
      background-color: var(--c-tag-light);
      padding: 5px 6px 4px 6px;
      width: fit-content;
      font-family: var(--font);
      font-size: 14px;
    }
  }

  .emat-number {
    height: 36px;
    min-width: 52px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: $border-radius;

    &::v-deep .emat-number-input {
      border-radius: $border-radius;

      .btn-group-arrows {
        .plus {
          border-top-right-radius: $border-radius;
        }

        .minus {
          border-bottom-right-radius: $border-radius;
        }
      }
    }
  }

  .prices {
    margin-left: 6px;
    width: 45px;
    text-align: right;
  }

  .price {
    font-family: var(--font);
    font-size: 14px;
    color: $black;
  }

  &:nth-child(odd) {
    background-color: var(--c-zebra-stripe);
  }

  &:nth-child(even) {
    background-color: $white;

    &:last-child {
      border-bottom-right-radius: $border-radius;
      border-bottom-left-radius: $border-radius;
    }
  }
}
</style>
